<layout>
  <top-bar>
    <sub-navigation>
      <sub-navigation-item path="/around" icon="near_me">{{ 'MAP.AROUND' | translate }}</sub-navigation-item>
    </sub-navigation>
  </top-bar>
  <left-panel [isExpanded]="false">
    <container
      [isScrollable]="true"
      verticalHeight="fill"
      [padding]="'small'"
      style="display: flex; flex-direction: column; gap: 4px">
      <title-section>
        <ubi-title [class]="activeType === 'device' ? 'active-color' : ''" [level]="2">
          {{ 'MAP.CLOSESTDEVICES' | translate }}
        </ubi-title>

        <actions>
          @if (displayRealDistance() && activeType === 'device') {
            <button matButton="filled" class="small" color="accent" (click)="clearETAAround()">
              {{ 'COMMON.BACK' | translate }}
            </button>
          } @else if (!displayRealDistance() && mapService.closestDevice?.length > 0) {
            <button matButton="filled" class="small" color="accent" (click)="goToETA('device')">
              {{ 'MAP.ITINERARY' | translate }}
            </button>
          }
        </actions>
      </title-section>

      @if (mapService.closestDevice?.length > 0) {
        @for (a of mapService.closestDevice; track a; let i = $index) {
          @if (i < devicesList) {
            <device-card
              [display]="displayRealDistance() && activeType === 'device' ? 'realDistance' : 'distance'"
              [d]="a.uid"
              [distance]="a.distance"></device-card>
          }
        }
        <div class="more-container">
          <mat-icon (click)="devicesList === 5 ? moreElements('device') : lessElements('device')">
            {{ devicesList === 5 ? 'expand_more' : 'expand_less' }}
          </mat-icon>
        </div>
      } @else {
        <p class="text-no-data">{{ 'COMMON.NODEVICESNEARBY' | translate }}</p>
      }

      <title-section>
        <ubi-title [class]="activeType === 'poi' ? 'active-color' : ''" [level]="2">
          {{ 'MAP.CLOSESTLANDMARKS' | translate }}
        </ubi-title>

        <actions>
          @if (displayRealDistance() && activeType === 'poi') {
            <button matButton="filled" class="small" color="accent" (click)="clearETAAround()">
              {{ 'COMMON.BACK' | translate }}
            </button>
          } @else if (!displayRealDistance() && mapService.closestPoi?.length > 0) {
            <button matButton="filled" class="small" color="accent" (click)="goToETA('poi')">
              {{ 'MAP.ITINERARY' | translate }}
            </button>
          }
        </actions>
      </title-section>

      @if (mapService.closestPoi?.length > 0) {
        @for (landmark of mapService.closestPoi; track landmark; let i = $index) {
          @if ($landmarksById()?.[landmark.uid] && i < poiList) {
            <landmark-card
              style="cursor: pointer"
              (click)="navigateToLandmark(landmark.uid, landmark.uid_parent)"
              [landmark]="$safeNavigationMigration($landmarksById()?.[landmark.uid])"
              [distanceData]="
                displayRealDistance() && activeType === 'poi'
                  ? { distance: realClosestData()[landmark.uid].realDistance, prefix: '~' }
                  : { distance: landmark.distance, prefix: '' }
              " />
          }
        }
        <div class="more-container">
          <mat-icon (click)="poiList === 5 ? moreElements('poi') : lessElements('poi')">
            {{ poiList === 5 ? 'expand_more' : 'expand_less' }}
          </mat-icon>
        </div>
      } @else {
        <p class="text-no-data">{{ 'COMMON.NOPOISNEARBY' | translate }}</p>
      }
    </container>
  </left-panel>
</layout>
